import React from "react";
import { Button, Box, LinearProgress } from "@mui/material";
import { useCustomThemeContext } from "../../providers/customThemeProvider";

// Define the props for the EventSubmitButton component
interface SubmitButtonProps {
  isBeingSubmitted: boolean; // Indicates if the form is being submitted
  handleSubmit: (e: React.FormEvent) => Promise<void>; // Function to handle form submission
  text?: string; // Optional text to display on the button
}

// Define the EventSubmitButton functional component
const EventSubmitButton: React.FC<SubmitButtonProps> = ({
  isBeingSubmitted,
  handleSubmit,
  text = "submit",
}) => {
  // Get the theme from the custom theme context
  const { theme } = useCustomThemeContext();

  return (
    <>
      {/* Render the submit button if the form is not being submitted */}
      {!isBeingSubmitted && (
        <Button
          data-testid="submit-button" // Test ID for the submit button
          onClick={handleSubmit} // Set the click handler for the button
          type="submit" // Set the button type to submit
          variant="contained" // Use the contained variant for the button
          color="primary" // Set the button color to primary
          sx={{ mt: 2, mb: 2, width: "100%" }} // Apply custom styles to the button
        >
          {text} {/* Display the button text */}
        </Button>
      )}
      {/* Render the loading box if the form is being submitted */}
      {isBeingSubmitted && (
        <Box
          data-testid="loading-box" // Test ID for the loading box
          border={1} // Set the border for the loading box
        >
          {/* Render the linear progress bar inside the loading box */}
          <LinearProgress data-testid="loading-progress" />
        </Box>
      )}
    </>
  );
};

export default EventSubmitButton;
